/**
 * Generic CSV export helpers shared across pages (Analytics, Audit Log, …).
 */

export type CsvCell = string | number | boolean | null | undefined;

/** Quote a CSV cell per RFC 4180 (wrap in quotes, double any inner quotes). */
export function csvEscape(value: CsvCell): string {
  const s = value === null || value === undefined ? '' : String(value);
  return /[",\r\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}

/** Build a CSV string from headers + rows. */
export function toCsv(headers: string[], rows: CsvCell[][]): string {
  return [headers, ...rows].map(r => r.map(csvEscape).join(',')).join('\r\n');
}

/** Make a value safe to use inside a filename. */
export function toFilenamePart(value: string): string {
  return value.replace(/[^a-zA-Z0-9._-]+/g, '-');
}

/** Build a CSV and trigger a browser download. */
export function downloadCsv(filename: string, headers: string[], rows: CsvCell[][]): void {
  // BOM so Excel opens UTF-8 correctly
  const blob = new Blob(['﻿' + toCsv(headers, rows)], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
